import { UseInfiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useGetNewestBoardPostCursorPageQuery } from '@/hooks/community/mobile/community.gql.impl';
import * as Types from '@/types/bff/gql-schema';

const useGetNewestBoardPostInfinite = <T,>(
  variables: Types.GetNewestBoardPostCursorPageQueryVariables,
  queryOptions?: UseInfiniteQueryOptions<Types.GetNewestBoardPostCursorPageQuery, AxiosError, T>,
) => {
  return useInfiniteQuery<Types.GetNewestBoardPostCursorPageQuery, AxiosError, T>(
    ['getNewestBoardPostCursorPage', variables],
    ({ pageParam }) => {
      return useGetNewestBoardPostCursorPageQuery.fetcher({
        request: {
          ...variables.request,
          pivot: pageParam,
        },
      })();
    },
    {
      ...queryOptions,
      getNextPageParam: (lastPage: Types.GetNewestBoardPostCursorPageQuery) => {
        const size = variables.request.size as number;
        if (!lastPage) {
          return undefined;
        }
        if (lastPage.newestBoardPostCursorPage.elements.length < size) {
          return undefined;
        }

        return lastPage.newestBoardPostCursorPage.pivot;
      },
    },
  );
};

useGetNewestBoardPostInfinite.getKey = (variables: Types.GetNewestBoardPostCursorPageQueryVariables) => {
  return ['getNewestBoardPostCursorPage', variables];
};
export default useGetNewestBoardPostInfinite;
